import React from 'react';
import SearchLanding from '../components/SearchLanding';

function Search() {
  return (
    <SearchLanding
    />
  );
}

export default Search;
